export const enlaceAplicacionCalculadoraPresupuestos =
  "https://jleonn.github.io/CalculaTuPresupuesto/#/";

export const enlaceRepositorioCalculadoraPresupuestos =
  "https://github.com/JLeonN/CalculaTuPresupuesto";
